/* ==========================================================
   AVALNA OVERLAY HEADER — Batch 17C
   IntersectionObserver toggles body classes for overlay/scrolled states.
   Homepage-only. Graceful degradation when light logo not uploaded.
   ========================================================== */

(function avalnaOverlayHeader() {
  var root = document.documentElement;

  if (!root.classList.contains('avalna-header-overlay')) return;

  var heroSection = document.querySelector('#MainContent > .shopify-section:first-child');
  if (!heroSection) return;

  var announcementBar = document.querySelector('.avalna-announcement-bar');
  var sectionHeader = document.querySelector('.section-header');

  function avalnaUpdateHeaderPosition() {
    if (!announcementBar || !sectionHeader) return;
    var barHeight = announcementBar.offsetHeight;
    sectionHeader.style.top = barHeight + 'px';
  }

  function avalnaSetOverlayState() {
    root.classList.remove('avalna-header-scrolled');
    root.classList.add('avalna-header-overlay');
    avalnaUpdateHeaderPosition();
  }

  function avalnaSetScrolledState() {
    root.classList.remove('avalna-header-overlay');
    root.classList.add('avalna-header-scrolled');
    if (announcementBar && sectionHeader) {
      sectionHeader.style.top = announcementBar.offsetHeight + 'px';
    }
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          avalnaSetOverlayState();
        } else {
          avalnaSetScrolledState();
        }
      });
    },
    {
      root: null,
      threshold: 0,
      rootMargin: '0px 0px -50px 0px'
    }
  );

  observer.observe(heroSection);

  avalnaUpdateHeaderPosition();

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      var isHeroVisible = heroSection.getBoundingClientRect().bottom > 50;
      if (isHeroVisible) {
        avalnaSetOverlayState();
      } else {
        avalnaSetScrolledState();
      }
    }
  });

  window.addEventListener('resize', function () {
    avalnaUpdateHeaderPosition();
  });
})();
